import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { NavigationBehaviorOptions, NavigationEnd, NavigationExtras, Router, UrlCreationOptions, UrlTree } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private history: string[] = [];

  constructor(
    private router: Router,
    private location: Location,
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        let lastUrl = this.historyLast();
        if (lastUrl != event.urlAfterRedirects) {
          this.history.push(event.urlAfterRedirects);
        }
      }
    });
    this.location.subscribe((event) => {
      this.history.pop();
    });
  }

  private historyLast() {
    return this.history[this.history.length - 1];
  }

  /**
   * Retorna para a ultima url utilizando o histórico de navegação do brower (serviço Location).
   * Se não possuir outra url no historico de navegacao (pilha history) além da url atual, a url atual é substituida pela rota indicada em commands e extras. Se commands é undefined ou array vazio [], redireciona para a rota raiz /.
   * @param commands
   * @param extras
   */
  back(commands?: any[], extras?: NavigationExtras) {
    if (this.history.length > 1) {
      this.location.back();
    } else {
      let lastUrl = this.historyLast();
      if (lastUrl.indexOf('referer') > 0) {
        this.location.back();
      } else if (commands != undefined && commands.length > 0) {
        this.replace(commands, extras);
      } else {
        this.replace(['/']);
      }
    }
  }

  /**
   * Substitui a ultima url do histórico de navegação do brower (serviço Location) pela rota indicada em commands e extras.
   * @param commands
   * @param extras
   */
  replace(commands: any[], extras?: NavigationExtras) {
    let urlTree = this.router.createUrlTree(commands, extras);
    let url = this.router.serializeUrl(urlTree);
    this.history.pop();
    this.location.replaceState(url);
    this.router.navigate(commands, extras);
  }
}
